import React__default from 'react';

const Loader = ({ isFullPage = true }) => {
    return (React__default.createElement("div", { id: "pageLoader" },
        React__default.createElement("div", { id: "preloader", style: { position: isFullPage ? "fixed" : "inherit" } },
            React__default.createElement("div", { id: "status" },
                React__default.createElement("div", { className: "spinner" },
                    React__default.createElement("div", { className: "double-bounce1" }),
                    React__default.createElement("div", { className: "double-bounce2" }))))));
};

export { Loader as default };
//# sourceMappingURL=loader.js.map
